import { render, staticRenderFns } from "./compression-chart.vue?vue&type=template&id=134a602a&scoped=true"
import script from "./compression-chart.vue?vue&type=script&lang=js"
export * from "./compression-chart.vue?vue&type=script&lang=js"
import style0 from "./compression-chart.vue?vue&type=style&index=0&id=134a602a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134a602a",
  null
  
)

export default component.exports